// extracted by mini-css-extract-plugin
export default {"root":"PriceFilterPopup_root__eQrkR","searchDrawerFilter":"PriceFilterPopup_searchDrawerFilter__ZnVvL"};